export const lightColors = () => {
    localStorage.setItem('papercolor', '#f9f9f9')
    localStorage.setItem('navcolor', '#424242')
    localStorage.setItem('navicon', '#fafafa')
    localStorage.setItem('colorsdiv', '#e0e0e0')
    localStorage.setItem('colorsappbar', '#4d4d4d')
    localStorage.setItem('statusiconbg', '#424242')
    localStorage.setItem('statusiconcolor', '#fafafa')
    localStorage.setItem('iconprimary', '#fafafa')
    localStorage.setItem('iconsecondary', '#fafafa')
    localStorage.setItem('pauseiconcolor', '#424242')
    localStorage.setItem('actionplaybg', '#2196f3')
    localStorage.setItem('actioneditbg', '#ff9800')
    localStorage.setItem('actionremovebg', '#f44336')
    localStorage.setItem('actioncheckbg', '#43a047')
    localStorage.setItem('actionpausebg', '#fdd835')
    localStorage.setItem('removeicn', '#757575')
    localStorage.setItem('trail', '#a6a6a6')
    localStorage.setItem('warning', '#f9a825')
    localStorage.setItem('delay', '#e53935')
    localStorage.setItem('projectBox', '#e0e0e0')
    localStorage.setItem('primaryDark', '#212121')
    localStorage.setItem('primaryLight', '#212121')
    localStorage.setItem('menubg', '#e0e0e0')
    localStorage.setItem('menutxt', '#212121')
    localStorage.setItem('linktxt', '#757575')
    localStorage.setItem('googlebtnbg', '#db4437')
    localStorage.setItem('googlebtncol', '#ffffff')
    localStorage.setItem('kanbantodo', '#ffeb3b')
    localStorage.setItem('kanbanprogress', '#42a5f5')
    localStorage.setItem('kanbandone', '#66bb6a')
    localStorage.setItem('kanbanitem', '#fafafa')
    localStorage.setItem('kanbantask', '#212121')
    localStorage.setItem('buttonbox', 'rgba(255, 255, 255, 0.6)')
}